import { List } from "../Components/index.js";

export default [
    {
        path: "/vehicle/fuel-list",
        component: List,
        name: "vehicle.fuel.list",
        meta: {
            requiresAuth: true,
        },
    },
];
